import { RestClient } from "../RestClient";

// 請求締処理データ検索リクエスト
export type B030010FindRequest = {
  seikyuYmd: string;
  seikyushimeYmd: string;
  nyukinYmd: string;
  seikyujokenKbn: string;
} & Partial<{
  urikakeshainCd: string;
  seikyucdFrom1: string;
  seikyushitencdFrom1: string;
  seikyucdTo1: string;
  seikyushitencdTo1: string;
  seikyucdFrom2: string;
  seikyushitencdFrom2: string;
  seikyucdTo2: string;
  seikyushitencdTo2: string;
  seikyucdFrom3: string;
  seikyushitencdFrom3: string;
  seikyucdTo3: string;
  seikyushitencdTo3: string;
  seikyucdFrom4: string;
  seikyushitencdFrom4: string;
  seikyucdTo4: string;
  seikyushitencdTo4: string;
  seikyucd1: string;
  seikyushitencd1: string;
  seikyucd2: string;
  seikyushitencd2: string;
  seikyucd3: string;
  seikyushitencd3: string;
  seikyucd4: string;
  seikyushitencd4: string;
  seikyucd5: string;
  seikyushitencd5: string;
  seikyucd6: string;
  seikyushitencd6: string;
  seikyucd7: string;
  seikyushitencd7: string;
  seikyucd8: string;
  seikyushitencd8: string;
  seikyucd9: string;
  seikyushitencd9: string;
  seikyucd10: string;
  seikyushitencd10: string;
  seikyucd11: string;
  seikyushitencd11: string;
  seikyucd12: string;
  seikyushitencd12: string;
  seikyucd13: string;
  seikyushitencd13: string;
  seikyucd14: string;
  seikyushitencd14: string;
  seikyucd15: string;
  seikyushitencd15: string;
  seikyucd16: string;
  seikyushitencd16: string;
  seikyucd17: string;
  seikyushitencd17: string;
  seikyucd18: string;
  seikyushitencd18: string;
  seikyucd19: string;
  seikyushitencd19: string;
  seikyucd20: string;
  seikyushitencd20: string;
}>;

export type B030010FindResponse = {
  taishoseikyuKensu: string;
  taishouridenpyoKensu: string;
  taishonyukindenpyoKensu: string;
};

// 請求締処理データ検索処理
export const B030010Find = (props: B030010FindRequest) => {
  return RestClient.get<B030010FindResponse>("b030010/find", {
    params: props,
  });
};

// 請求締処理実行リクエスト
export type B030010CreateRequest = {
  seikyuYmd: string;
  seikyushimeYmd: string;
  nyukinYmd: string;
  seikyujokenKbn: string;
  taishoseikyuKensu: string;
  taishouridenpyoKensu: string;
  taishonyukindenpyoKensu: string;
} & Partial<{
  urikakeshainCd: string;
  seikyucdFrom1: string;
  seikyushitencdFrom1: string;
  seikyucdTo1: string;
  seikyushitencdTo1: string;
  seikyucdFrom2: string;
  seikyushitencdFrom2: string;
  seikyucdTo2: string;
  seikyushitencdTo2: string;
  seikyucdFrom3: string;
  seikyushitencdFrom3: string;
  seikyucdTo3: string;
  seikyushitencdTo3: string;
  seikyucdFrom4: string;
  seikyushitencdFrom4: string;
  seikyucdTo4: string;
  seikyushitencdTo4: string;
  seikyucd1: string;
  seikyushitencd1: string;
  seikyucd2: string;
  seikyushitencd2: string;
  seikyucd3: string;
  seikyushitencd3: string;
  seikyucd4: string;
  seikyushitencd4: string;
  seikyucd5: string;
  seikyushitencd5: string;
  seikyucd6: string;
  seikyushitencd6: string;
  seikyucd7: string;
  seikyushitencd7: string;
  seikyucd8: string;
  seikyushitencd8: string;
  seikyucd9: string;
  seikyushitencd9: string;
  seikyucd10: string;
  seikyushitencd10: string;
  seikyucd11: string;
  seikyushitencd11: string;
  seikyucd12: string;
  seikyushitencd12: string;
  seikyucd13: string;
  seikyushitencd13: string;
  seikyucd14: string;
  seikyushitencd14: string;
  seikyucd15: string;
  seikyushitencd15: string;
  seikyucd16: string;
  seikyushitencd16: string;
  seikyucd17: string;
  seikyushitencd17: string;
  seikyucd18: string;
  seikyushitencd18: string;
  seikyucd19: string;
  seikyushitencd19: string;
  seikyucd20: string;
  seikyushitencd20: string;
}>;

// 請求締処理実行
export const B030010Create = (props: B030010CreateRequest) => {
  return RestClient.post("b030010/create", props);
};

// 請求締処理キャンセルリクエスト
export type B030010UpdateRequest = {
  seikyushimeYmd: string;
  seikyujokenKbn: string;
} & Partial<{
  urikakeshainCd: string;
  seikyucdFrom1: string;
  seikyushitencdFrom1: string;
  seikyucdTo1: string;
  seikyushitencdTo1: string;
  seikyucdFrom2: string;
  seikyushitencdFrom2: string;
  seikyucdTo2: string;
  seikyushitencdTo2: string;
  seikyucdFrom3: string;
  seikyushitencdFrom3: string;
  seikyucdTo3: string;
  seikyushitencdTo3: string;
  seikyucdFrom4: string;
  seikyushitencdFrom4: string;
  seikyucdTo4: string;
  seikyushitencdTo4: string;
  seikyucd1: string;
  seikyushitencd1: string;
  seikyucd2: string;
  seikyushitencd2: string;
  seikyucd3: string;
  seikyushitencd3: string;
  seikyucd4: string;
  seikyushitencd4: string;
  seikyucd5: string;
  seikyushitencd5: string;
  seikyucd6: string;
  seikyushitencd6: string;
  seikyucd7: string;
  seikyushitencd7: string;
  seikyucd8: string;
  seikyushitencd8: string;
  seikyucd9: string;
  seikyushitencd9: string;
  seikyucd10: string;
  seikyushitencd10: string;
  seikyucd11: string;
  seikyushitencd11: string;
  seikyucd12: string;
  seikyushitencd12: string;
  seikyucd13: string;
  seikyushitencd13: string;
  seikyucd14: string;
  seikyushitencd14: string;
  seikyucd15: string;
  seikyushitencd15: string;
  seikyucd16: string;
  seikyushitencd16: string;
  seikyucd17: string;
  seikyushitencd17: string;
  seikyucd18: string;
  seikyushitencd18: string;
  seikyucd19: string;
  seikyushitencd19: string;
  seikyucd20: string;
  seikyushitencd20: string;
}>;

// 請求締処理キャンセル処理
export const B030010Update = (props: B030010UpdateRequest) => {
  return RestClient.put("b030010/update", props);
};
